import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-flixbus-promotion',
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule],
  templateUrl: './flixbus-promotion.component.html',
  styleUrls: ['./flixbus-promotion.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ transform: 'translateY(10px)', opacity: 0 }),
        animate('0.3s ease-out',
          style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'translateY(0)', opacity: 1 }),
        animate('0.2s ease-out',
          style({ transform: 'translateY(10px)', opacity: 0 }))
      ]),
    ]),
  ]
})
export class FlixbusPromotionComponent {
  public isVisible = false;

  constructor(private router: Router) {
    // Check if user has previously dismissed the promotion
    if (typeof window !== 'undefined' && window.localStorage) {
      const dismissed = localStorage.getItem('flixbus-promotion-dismissed');
      if (!dismissed) {
        this.isVisible = true;
      }
    }
  }

  close() {
    this.isVisible = false;
    // Remember user's choice for this session
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem('flixbus-promotion-dismissed', 'true');
    }
  }
}
